export const getEndOfTag3d = (tag: string, splitChar = ".") => {
	const [, , t] = tag.split(splitChar)
	return t
}

export const getTag3dRoot = (tag: string, splitChar = ".") => {
	const [l1, l2] = tag.split(splitChar)
	return [l1, l2].join(splitChar)
}
